import React from 'react';
import { getBlogPost } from '../utils/blogData';

function BlogPost({ slug }) {
  const post = getBlogPost(slug);
  if (!post) return null;

  const back = (e) => {
    e.preventDefault();
    window.location.hash = '';
  };

  const renderContent = () => {
    const parts = [];
    const segments = post.content.split(/(<iframe[^>]*>.*?<\/iframe>)/gs);
    segments.forEach((segment, idx) => {
      if (segment.startsWith('<iframe')) {
        parts.push(<div key={idx} dangerouslySetInnerHTML={{ __html: segment }} />);
      } else {
        segment.split('\n\n').forEach((paragraph, pIdx) => {
          if (!paragraph.trim()) return;
          if (paragraph.startsWith('##')) {
            parts.push(<h2 key={`${idx}-${pIdx}`}>{paragraph.replace('## ', '')}</h2>);
          } else {
            const lines = paragraph.split('\n');
            parts.push(
              <p key={`${idx}-${pIdx}`}>
                {lines.map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    {i < lines.length - 1 && <br />}
                  </React.Fragment>
                ))}
              </p>
            );
          }
        });
      }
    });
    return parts;
  };

  return (
    <div className="post-wrap">
      <a href="#top" className="post-back" onClick={back}>← back</a>
      <div className="post-date">{post.date.toLowerCase()}</div>
      <h1 className="post-title">{post.title.toLowerCase()}</h1>
      <div className="post-body">{renderContent()}</div>
    </div>
  );
}

export default BlogPost;
